export const redirectUser = (user, navigate) => {
  if (!user) return;

  if (user.role === "admin") {
    navigate("/admin-dashboard");
  } else {
    navigate("/home");
  }
};